import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Unit, UnitService } from '../../services/unit.service';

@Component({
  selector: 'app-create-unit',
  templateUrl: './create-unit.component.html',
  styleUrls: ['./create-unit.component.css']
})
export class CreateUnitComponent implements OnInit {
  unitForm: FormGroup;

  tipos=[
    {name:'Elija un tipo...',value:''},
    {name:'Área',value:'Área'},
    {name:'Longitud',value:'Longitud'},
    {name:'Peso',value:'Peso'},
    {name:'Tiempo',value:'Tiempo'},
    {name:'Velocidad',value:'Velocidad'},
    {name:'Volumen Líquido',value:'Volumen Líquido'},
    {name:'Volumen Sólido',value:'Volumen Sólido'},
    {name:'Cantidad',value:'Cantidad'},
    {name: 'Otros',value:'Otros'},
  ];

  constructor(
    private unitService: UnitService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createForm();

  }

  createForm() {
    this.unitForm = this.fb.group({
      name: ['', Validators.required],
      symbol: ['', Validators.required],
      type: ['', Validators.required],
      value: ['', Validators.required],
      reference: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.unitService.addUnit(value);
  }
}
